export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/check-solid-b97dcdb972b562cb4dc4abcf6a0d288a.svg";